<div
  #contentElement
  class="content"
  [class.with-gradient]="!isOpened() && displayEnabled()"
  [style.height]="heightInPx()"
>
  <ng-content select="[spoilerContent]"></ng-content>
</div>

@if (displayEnabled()) {
  <div class="show-all-button-container">
    <button
      class="show-all-button"
      (click)="onToggle()"
      [class.opened]="isOpened()"
      [attr.data-analytics]="dataAnalytics"
    >
      @if (isOpened()) {
        {{ collapseText ? 'скрыть' : '' }}
        <ng-content select="[collapseText]"></ng-content>
      } @else {
        {{ showAllText ? 'показать все' : '' }}
        <ng-content select="[showAllText]"></ng-content>
      }
    </button>
  </div>
}
